import Joi from '../Joi';

const emailSchema = Joi.string()
  .email({ tlds: { allow: false } })
  .required();

/**
 * Validates that the email given is a valid email, has @ sign, domain name
 * @param {string} email string of the email address given
 *
 * @returns {boolean} whether the email is valid
 */

const validateEmail = (email) => {
  const res = emailSchema.validate(email);
  return !res.error;
};

export default validateEmail;
